import { render, staticRenderFns } from "./Ebook.vue?vue&type=template&id=03420922&scoped=true"
import script from "./Ebook.vue?vue&type=script&lang=js"
export * from "./Ebook.vue?vue&type=script&lang=js"
import style0 from "./Ebook.vue?vue&type=style&index=0&id=03420922&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03420922",
  null
  
)

export default component.exports